import { Component, OnInit } from "@angular/core";
import {
  Notification,
  NotificationService,
} from "src/app/services/notification.service";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
})
export class NotificationComponent implements OnInit {
  notification: Notification | undefined = undefined;

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.notificationService
      .get()
      .subscribe((data: Notification | undefined) => {
        this.notification = data;
      });
  }

  onClose() {
    this.notificationService.clear();
  }

  getTitle() {
    switch (this.notification?.type) {
      case "SUCCESS":
        return "Success";
      case "ERROR":
        return "Error";
      case "ABORTED":
        return "Aborted";
      default:
        return "";
    }
  }

  getMessage() {
    return this.notification?.message;
  }

  getIcon() {
    switch (this.notification?.type) {
      case "SUCCESS":
        return "check-circle-2";
      case "ERROR":
        return "x-circle";
      case "ABORTED":
        return "alert-circle";
      default:
        return "check-circle-2";
    }
  }

  getColor() {
    switch (this.notification?.type) {
      case "SUCCESS":
        return "text-oney";
      case "ERROR":
        return "text-red-400";
      case "ABORTED":
        return "text-orange-400";
      default:
        return "text-oney";
    }
  }
}
